module.exports = __webpack_public_path__ + "static/img/aa.b4ab4e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aa.png
// module id = /soT
// module chunks = 7